import {
  AUTHENTICATE_LOGIN_ACTIONS,
  AUTHENTICATE_REFRESH_TOKEN_ACTIONS,
  AUTHENTICATE_REGISTER_ACTIONS,
  AUTHENTICATE_LOGOUT_ACTIONS,
  AUTHENTICATE_ACTIVATE_ACTIONS,
  AUTHENTICATE_NOTIFICATION_ACTIONS,
  REMOVE_NOTIFICATION_ACTIONS,
  IS_USER_EXITS_ACTIONS,
  AUTHENTICATE_OAUTH_LOGIN_ACTIONS
} from "../../actionType/authenticate";
import { AUTHENTICATE_CHANGE_ACTIONS, AUTHENTICATE_DEVICE_LOGOUT_ACTIONS, AUTHENTICATE_FORGOT_ACTIONS, AUTHENTICATE_RESENDEMAIL_ACTIONS, CHANGE_ACCOUNT_PASSWORD_ACTIONS, IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS,AUTHENTICATE_GETEMAIL_OTP_ACTIONS } from "../../actionType/authenticate";
import { AUTHENTICATE_RESET_ACTIONS } from "../../actionType/authenticate";

const intialState = {
  loginSucessData: [],
  isloginLoader: false,
  OAuthlloginSucessData: [],
  isOAuthloginLoader: false,
  isRefreshLoader: false,
  RefreshSucessData: {},
  isRegisterLoader: false,
  registerSucessData: {},
  isForgotLoader: false,
  isResetLoader: false,
  isChangeEmailLoader: false,
  ActivateData: {},
  isActivateLoader: false,
  resendEmailData: {},
  isResendEmailLoader: false,
  isLogOutLoader: false,
  notificationData: [],
  isnotificationDataLoader: false,
  userExists: [],
  isUserExistsLoader: false,
  changePasswordData: {},
  isChangePasswordLoader: false,
  getOTPdata: {},
  isgetOTPLoader: false,
  isUserNameOrEmailAvailableLoader: false,
  isUserNameOrEmailAvailableData: {},
};

export const authenticateReducer = (
  state = intialState,
  { type, payload }: any
) => {
  switch (type) {
    case AUTHENTICATE_LOGIN_ACTIONS.AUTHENTICATE_LOGIN_REQUEST:
      return { ...state, loginSucessData: payload, isOAuthloginLoader: false };
    case AUTHENTICATE_LOGIN_ACTIONS.AUTHENTICATE_LOGIN_RESPONSE:
      return { ...state, loginSucessData: payload, isOAuthloginLoader: true };
    case AUTHENTICATE_LOGIN_ACTIONS.AUTHENTICATE_LOGIN_ERROR:
      return { ...state, loginSucessData: payload, isOAuthloginLoader: false };

    //OAUTH_LOGIN
    case AUTHENTICATE_OAUTH_LOGIN_ACTIONS.AUTHENTICATE_OAUTH_LOGIN_REQUEST:
      return { ...state, OAuthlloginSucessData: payload, isloginLoader: false };
    case AUTHENTICATE_OAUTH_LOGIN_ACTIONS.AUTHENTICATE_OAUTH_LOGIN_RESPONSE:
      return { ...state, OAuthlloginSucessData: payload, isloginLoader: true };
    case AUTHENTICATE_OAUTH_LOGIN_ACTIONS.AUTHENTICATE_OAUTH_LOGIN_ERROR:
      return { ...state, OAuthlloginSucessData: payload, isloginLoader: false };

    case AUTHENTICATE_REFRESH_TOKEN_ACTIONS.AUTHENTICATE_REFRESH_TOKEN_REQUEST:
      return { ...state, RefreshSucessData: payload, isRefreshLoader: true };
    case AUTHENTICATE_REFRESH_TOKEN_ACTIONS.AUTHENTICATE_REFRESH_TOKEN_RESPONSE:
      return { ...state, RefreshSucessData: payload, isRefreshLoader: false };
    case AUTHENTICATE_REFRESH_TOKEN_ACTIONS.AUTHENTICATE_REFRESH_TOKEN_ERROR:
      return { ...state, RefreshSucessData: payload, isRefreshLoader: false };

    case AUTHENTICATE_REGISTER_ACTIONS.AUTHENTICATE_REGISTER_REQUEST:
      return { ...state, registerSucessData: payload, isRegisterLoader: false };
    case AUTHENTICATE_REGISTER_ACTIONS.AUTHENTICATE_REGISTER_RESPONSE:
      return { ...state, registerSucessData: payload, isRegisterLoader: true };
    case AUTHENTICATE_REGISTER_ACTIONS.AUTHENTICATE_REGISTER_ERROR:
      return { ...state, registerSucessData: payload, isRegisterLoader: false };
//AUTHENTICATE_OTP
    case AUTHENTICATE_GETEMAIL_OTP_ACTIONS.AUTHENTICATE_GETEMAIL_OTP_REQUEST:
      return { ...state, getOTPdata: payload, isgetOTPLoader: false };
    case AUTHENTICATE_GETEMAIL_OTP_ACTIONS.AUTHENTICATE_GETEMAIL_OTP_RESPONSE:
      return { ...state, getOTPdata: payload, isgetOTPLoader: true };
    case AUTHENTICATE_GETEMAIL_OTP_ACTIONS.AUTHENTICATE_GETEMAIL_OTP_ERROR:
      return { ...state, getOTPdata: payload, isgetOTPLoader: false };

    case AUTHENTICATE_LOGOUT_ACTIONS.AUTHENTICATE_LOGOUT_REQUEST:
      return { ...state, isLogOutLoader: false };
    case AUTHENTICATE_LOGOUT_ACTIONS.AUTHENTICATE_LOGOUT_RESPONSE:
      return { ...state, isLogOutLoader: true };
    case AUTHENTICATE_LOGOUT_ACTIONS.AUTHENTICATE_LOGOUT_ERROR:
      return { ...state, isLogOutLoader: false };
    //DEVICE LOGOUT 
    case AUTHENTICATE_DEVICE_LOGOUT_ACTIONS.AUTHENTICATE_DEVICE_LOGOUT_REQUEST:
      return { ...state, isLogOutLoader: false };
    case AUTHENTICATE_DEVICE_LOGOUT_ACTIONS.AUTHENTICATE_DEVICE_LOGOUT_RESPONSE:
      return { ...state, isLogOutLoader: true };
    case AUTHENTICATE_DEVICE_LOGOUT_ACTIONS.AUTHENTICATE_DEVICE_LOGOUT_ERROR:
      return { ...state, isLogOutLoader: false };

    case AUTHENTICATE_FORGOT_ACTIONS.AUTHENTICATE_FORGOT_REQUEST:
      return { ...state, isLogOutLoader: false };
    case AUTHENTICATE_FORGOT_ACTIONS.AUTHENTICATE_FORGOT_RESPONSE:
      return { ...state, isLogOutLoader: true };
    case AUTHENTICATE_FORGOT_ACTIONS.AUTHENTICATE_FORGOT_ERROR:
      return { ...state, isLogOutLoader: false };

    case AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_REQUEST:
      return { ...state, isResetLoader: false };
    case AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_RESPONSE:
      return { ...state, isResetLoader: true };
    case AUTHENTICATE_RESET_ACTIONS.AUTHENTICATE_RESET_ERROR:
      return { ...state, isResetLoader: false };

    //AUTHENTICATE_CHANGE_ACTIONS
    case AUTHENTICATE_CHANGE_ACTIONS.AUTHENTICATE_CHANGE_REQUEST:
      return { ...state, isChangeEmailLoader: false };
    case AUTHENTICATE_CHANGE_ACTIONS.AUTHENTICATE_CHANGE_RESPONSE:
      return { ...state, isChangeEmailLoader: true };
    case AUTHENTICATE_CHANGE_ACTIONS.AUTHENTICATE_CHANGE_ERROR:
      return { ...state, isChangeEmailLoader: false };


    case AUTHENTICATE_ACTIVATE_ACTIONS.AUTHENTICATE_ACTIVATE_REQUEST:
      return { ...state, isActivateLoader: false };
    case AUTHENTICATE_ACTIVATE_ACTIONS.AUTHENTICATE_ACTIVATE_RESPONSE:
      return { ...state, ActivateData: payload, isActivateLoader: true };
    case AUTHENTICATE_ACTIVATE_ACTIONS.AUTHENTICATE_ACTIVATE_ERROR:
      return { ...state, ActivateData: payload, isActivateLoader: false };

    // Resend activation email
    case AUTHENTICATE_RESENDEMAIL_ACTIONS.AUTHENTICATE_RESENDEMAIL_REQUEST:
      return { ...state, isResendEmailLoader: false };
    case AUTHENTICATE_RESENDEMAIL_ACTIONS.AUTHENTICATE_RESENDEMAIL_RESPONSE:
      return { ...state, resendEmailData: payload, isResendEmailLoader: true };
    case AUTHENTICATE_RESENDEMAIL_ACTIONS.AUTHENTICATE_RESENDEMAIL_ERROR:
      return { ...state, resendEmailData: payload, isResendEmailLoader: false };

    // NOTIFICATION_DATA:
    case AUTHENTICATE_NOTIFICATION_ACTIONS.AUTHENTICATE_NOTIFICATION_REQUEST:
      return { ...state, isnotificationDataLoader: false };
    case AUTHENTICATE_NOTIFICATION_ACTIONS.AUTHENTICATE_NOTIFICATION_RESPONSE:
      return { ...state, notificationData: payload, isnotificationDataLoader: true };
    case AUTHENTICATE_NOTIFICATION_ACTIONS.AUTHENTICATE_NOTIFICATION_ERROR:
      return { ...state, notificationData: payload, isnotificationDataLoader: false };
    // NOTIFICATION_DATA:
    case REMOVE_NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION_REQUEST:
      return { ...state, };
    case REMOVE_NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION_RESPONSE:
      return { ...state, };
    case REMOVE_NOTIFICATION_ACTIONS.REMOVE_NOTIFICATION_ERROR:
      return { ...state, };

    //IS_USER_EXIST
    case IS_USER_EXITS_ACTIONS.IS_USER_EXITS_REQUEST:
      return { ...state, userExists: payload, isUserExistsLoader: false };
    case IS_USER_EXITS_ACTIONS.IS_USER_EXITS_RESPONSE:
      return { ...state, userExists: payload, isUserExistsLoader: true };
    case IS_USER_EXITS_ACTIONS.IS_USER_EXITS_ERROR:
      return { ...state, userExists: payload, isUserExistsLoader: false };

    //CHANGE_ACCOUNT_PASSWORD
    case CHANGE_ACCOUNT_PASSWORD_ACTIONS.CHANGE_ACCOUNT_PASSWORD_REQUEST:
      return { ...state, changePasswordData: payload, isChangePasswordLoader: false };
    case CHANGE_ACCOUNT_PASSWORD_ACTIONS.CHANGE_ACCOUNT_PASSWORD_RESPONSE:
      return { ...state, changePasswordData: payload, isChangePasswordLoader: true };
    case CHANGE_ACCOUNT_PASSWORD_ACTIONS.CHANGE_ACCOUNT_PASSWORD_ERROR:
      return { ...state, changePasswordData: payload, isChangePasswordLoader: false };

    //IS_USER_NAME_OR_EMAIL_AVAILABLE
    case IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS.IS_USER_NAME_OR_EMAIL_AVAILABLE_REQUEST:
      return { ...state, isUserNameOrEmailAvailableData: payload, isUserNameOrEmailAvailableLoader: false };
    case IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS.IS_USER_NAME_OR_EMAIL_AVAILABLE_RESPONSE:
      return { ...state, isUserNameOrEmailAvailableData: payload, isUserNameOrEmailAvailableLoader: true };
    case IS_USER_NAME_OR_EMAIL_AVAILABLE_ACTIONS.IS_USER_NAME_OR_EMAIL_AVAILABLE_ERROR:
      return { ...state, isUserNameOrEmailAvailableData: payload, isUserNameOrEmailAvailableLoader: false };

    default:
      return state;
  }
};
